export default __webpack_public_path__ + "static/media/fcb.fa4e714c.png";